import { FC, useState } from 'react';

import { AddDocumentIcon } from '../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '../../../../components/hover-card/index';
import { PaginationController } from '../../../../components/pagination-controller/index';
import { EventHooks, useFormat } from '../../../../hooks/index';
import {
  ConversionEventItem,
  eventFormType,
  EventTypeBackend,
} from '../../../../types/events.types';
import { getS3FileOriginalName } from '../../../../utils/get-s3file-original-name.util';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Conversion: FC<CardProps> = ({ event, companyId, openFileUploadModal }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { format } = useFormat();
  const { items, totalPages } = EventHooks.useTransactions<ConversionEventItem>({
    eventId: event.id,
    eventType: EventTypeBackend.CONVERSION,
    companyId: companyId,
    currentPage,
  });

  if (event.type !== EventTypeBackend.CONVERSION) return <></>;

  const { type, filesLinks } = event;

  return (
    <>
      {items.map(({ date, fromShareClass, stakeholder, toShareClass, sharesCount }, i) => (
        <div
          className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm"
          key={i + stakeholder.id}
        >
          <TransactionTitleItem
            createdAt={format(date, 'dd/MM/yyyy')}
            name={stakeholder?.fullName}
          />
          <TransactionOverviewItem
            title={'Transaction Type'}
            value={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="FROM_SHARE_CLASS" />}
            value={fromShareClass?.name}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TO_SHARE_CLASS" />}
            value={toShareClass?.name}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="NO_OF_SHARES" />}
            value={sharesCount?.toLocaleString('en-US')}
          />
          {filesLinks.length > 0 && (
            <TransactionOverviewItem
              title={<AppFormattedMessage id="DOCUMENTS" />}
              value={
                <HoverCard>
                  <HoverCardTrigger onClick={() => openFileUploadModal(filesLinks)}>
                    <AddDocumentIcon className="cursor-pointer" />
                  </HoverCardTrigger>

                  <HoverCardContent
                    className="max-w-[360px] rounded-lg bg-[#101828] px-3 py-2"
                    side="top"
                  >
                    <span className="block w-full truncate p-0 text-label-md font-[550] text-white">
                      {filesLinks.length === 1
                        ? getS3FileOriginalName(filesLinks[0])
                        : `Download ${filesLinks.length} files`}
                    </span>
                  </HoverCardContent>
                </HoverCard>
              }
            />
          )}
        </div>
      ))}

      <PaginationController
        className="mt-6 shrink-0"
        currentPage={currentPage}
        onClick={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  );
};
